<template>

       <nav class="navbar  navbar-expand-lg navbar-light  bg-light-espais   z-logo position-absolute w-100" v-bind:class="[fondoOscuro() ? 'letra-blanca' : 'letra-negra']">
           <button class="navbar-toggler ml-auto" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo03" aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

            <router-link v-if="windowWidth > 991" to="/"  class="navbar-brand"><img :src="logo" alt="" class="logo img-fluid"></router-link>
            <router-link v-else to="/"  class="navbar-brand"><img :src="logo_acostado" alt="" class="logo-responsive"></router-link>
         
      
            <!-- <router-link  to="/"  class="navbar-brand"><img :src="logo_responsive" alt="" class="logo-responsive img-fluid"></router-link> -->

              <div class="collapse navbar-collapse mt-2" id="navbarTogglerDemo03">
                <ul class="navbar-nav ml-auto mt-lg-0">
                  <li class="nav-item dropdown">
                    <a  @click.native="closeMenu($event)" class="nav-link dropdown-toggle" id="obras" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  href="#" >OBRAS</a>
                     <div class="dropdown-menu" aria-labelledby="obras">
                        <router-link @click.native="closeMenu($event)" class="dropdown-item"  tag="a" to="/obras_comerciales_secciones">Arquitectura Comercial</router-link>
                        <router-link @click.native="closeMenu($event)" class="dropdown-item" tag="a" to="/obras_corporativas"> Arquitectura Corporativa</router-link>
                        <router-link @click.native="closeMenu($event)" class="dropdown-item" tag="a" to="/obras_residenciales">Arquitectura Residencial</router-link>
                      </div>
                  </li>
                  <li class="nav-item dropdown">
                    <a  @click.native="closeMenu($event)" class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  href="#" >PROYECTOS</a>
                      <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <router-link @click.native="closeMenu($event)" class="dropdown-item" tag="a" to="/proyectos_comerciales_secciones">Arquitectura Comercial</router-link>
                        <router-link @click.native="closeMenu($event)" class="dropdown-item" tag="a" to="/proyectos_corporativos"> Arquitectura Corporativa</router-link>
                        <router-link @click.native="closeMenu($event)" class="dropdown-item" tag="a" to="/proyectos_residenciales">Arquitectura Residencial</router-link>
                      </div>
                  </li>
                  <li class="nav-item">
                    <router-link to="/noticias" @click.native="closeMenu($event)" class="nav-link"  tag="a">NOVEDADES</router-link>
                    
                  </li>
                

                  <li  v-if="link_status" class="nav-item dropdown">
                    <a  @click.native="closeMenu($event)" class="nav-link dropdown-toggle text-uppercase" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  href="#" >{{link_nombre}}</a>
                      <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <router-link @click.native="closeMenu($event)" class="dropdown-item" tag="a" to="/curso/escaparatismo">Cursos de Escaparatismo</router-link>
                        <router-link @click.native="closeMenu($event)" class="dropdown-item" tag="a" to="/curso/visual">Cursos de Visual Merchandising</router-link>
               
                      </div>
                  </li>

                    <li class="nav-item">
                    <router-link to="/servicios" @click.native="closeMenu($event)" class="nav-link" tag="a">SERVICIOS</router-link>
                  </li>
                   <li class="nav-item dropdown">
                    <a  @click.native="closeMenu($event)" class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  href="#" >CONTACTO</a>
                      <div class="dropdown-menu contact-drop" aria-labelledby="navbarDropdown">
                        <router-link @click.native="closeMenu($event)" class="dropdown-item" tag="a" to="/mensaje">Consultas</router-link>
                         <router-link @click.native="closeMenu($event)" class="dropdown-item" tag="a" to="/presupuesto">Presupuestos</router-link>
                        <router-link @click.native="closeMenu($event)" class="dropdown-item" tag="a" to="/trabaja"> Trabaja con nosotros</router-link>
                       
                      </div>
                    </li>
                </ul>

              </div>
       </nav>
</template>

<script>
export default {
    data () {
    return {
      link_status:false,
      link_nombre:'',
      link:'',
      esnegro:false,
      logo: require('../assets/logo.svg'),
      logo_responsive: require('../assets/logo_responsive.svg'),
      logo_blanco: require('../assets/logo.png'),
      logo_negro: require('../assets/logo-negro.png'),
      logo_color: require('../assets/logo_color_nocuadro.png'),
      logo_acostado: require('../assets/logo_responsive.svg'),
      windowWidth: window.innerWidth,
      txt: ''
    }
  },
    methods:{
        loadLink () {
       this.$http.get(`https://espais.com.py/admin/api/1.1/tables/curso/rows/1`)
        .then(function (data) {
          if(data.body.data.status == 1){
            this.link_status = true;
            this.link_nombre = data.body.data.link_nombre;
            this.link = data.body.data.link;
         
          }
        })
      },
       fondoOscuro(){
          if (this.$route.path === '/404' || this.$route.path === '/'  || this.$route.name === 'curso'  ) {
           return true;
          }
         else {
          return false;
        }
       },
       paginaNegra(){
         if (this.$route.path === '/404' || this.$route.path === '/') {
           return false;
          }
         else {
          return true;
        }
       },
       closeMenu($event) {
          $($event.currentTarget).closest('.navbar-collapse').collapse('hide');
      }  
  },
   watch: {
    '$route' (){
      if (this.$route.path === '/404' || this.$route.path === '/') {
        this.esnegro = false;
      }
      else {
        this.esnegro = true;
      }
    },
    windowWidth(newWidth, oldWidth) {
     this.txt = `it changed to ${newWidth} from ${oldWidth}`;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.loadLink();
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      });
    })
  }
}
</script>





// WEBPACK FOOTER //
// src/components/Header.vue